const companyConfirm = r => require.ensure([], () => r(require('@/page/allowances/company/CompanyConfirm')), 'companyConfirm');
const allowances = r => require.ensure([], () => r(require('@/page/allowances/allowances')), 'allowances');
const epSuProjectList = r => require.ensure([], () => r(require('@/page/allowances/epidemicSubsidyProjectList/EpSuProjectList')), 'epSuProjectList');
const epSuProjectApplyInfo = r => require.ensure([], () => r(require('@/page/allowances/epidemicSubsidyProjectList/EpSuProjectApplyInfo')), 'epSuProjectApplyInfo');
const allowApproveList = r => require.ensure([], () => r(require('@/page/allowances/allowApproveList/AllowApproveList')), 'allowApproveList');
const epsuApproveInfo = r => require.ensure([], () => r(require('@/page/allowances/allowApproveList/EpsuApproveInfo')), 'epsuApproveInfo');
const epidemicSubsidy = r => require.ensure([], () => r(require('@/page/allowances/epidemicSubsidy')), 'epidemicSubsidy');
const changeApplyBatch = r=> require.ensure([], () => r(require('@/page/allowances/changeApplyBatch')), 'changeApplyBatch');

const allowancesRouter = {
    path: '/allowances',
    name: '疫情补贴管理',
    component: allowances,
    meta: {
        icon: 'expertInfo',
        right: [],
        isShowMenu: true,
    },
    children: [
        {
            path: '/epidemicSubsidy',
            component: epidemicSubsidy,
            name: '疫情防控补助',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: false
            }
        },
        {
            path: '/confirm',
            component: companyConfirm,
            name: '企业确认',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
        {
            path: '/epSuProjectList',
            component: epSuProjectList,
            name: '疫情补助项目列表',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
        {
            path: '/epSuProjectApplyInfo',
            component: epSuProjectApplyInfo,
            name: '疫情补助申请',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
        {
            path: '/epSuProjectInfo',
            component: epSuProjectApplyInfo,
            name: '疫情补助查看',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
        {
            path: '/allowApproveList',
            component: allowApproveList,
            name: '疫情补助审核',
            meta: {
                right: [],
                isShowMenu: true,
                keepAlive: false
            }
        },
        {
            path: '/epsuApproveInfo',
            component: epsuApproveInfo,
            name: '疫情补助审核详情',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
        {
            path: '/changeApplyBatch',
            component: changeApplyBatch,
            name: '疫情补助发起',
            meta: {
                right: [],
                isShowMenu: false,
                keepAlive: false
            }
        },
    ]
};
export default allowancesRouter;
